import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
// Prime React
import { BreadCrumb } from "primereact/breadcrumb";
import { TabPanel, TabView } from "primereact/tabview";

// components
import Panel from "../../../../components/panel/panel";
import TemplateList from "./TemplateList";
import DomainConfig from "./DomainConfig";
import DnsSettings from "./DnsSettings";

const ConfigWebSite = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { domain } = useParams();
  const { state } = useLocation();
  const [formData, setFormData] = useState({});
  const [templateConfig, setTemplateConfig] = useState({});
  const [publishLoading, setPublishLoading] = useState(false);
  const [publishMessage, setPublishMessage] = useState("");
  const [showBanner, setShowBanner] = useState(false);
  const [paymentConfirmed, setPaymentConfirmed] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  

  const [activeIndex, setActiveIndex] = useState(0);

  const items = [
    {
      template: () => (
        <Link
          to={`/enterpriseSettings/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Configurações do Empreendimento
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/enterpriseSettings/configWebSite/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Configurações do Site
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  return (
    <>
      <div>
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>

      <Panel>
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
          className="meu-tabview gap-4"
        >
          <TabPanel
            header="Escolha seu template"
            leftIcon="pi pi-code mx-2"
            className="gap-4"
          >
            <TemplateList
              enterprise_id={id}
            />
          </TabPanel>

          {/* <TabPanel
            header="Configurações do domínio"
            leftIcon="pi pi-cog mx-2"
            className="gap-4"
          >
            <DomainConfig />
          </TabPanel> */}

          <TabPanel
            header="Configurações do domínio / DNS"
            leftIcon="pi pi-cog mx-2"
            className="gap-4"
          >
            <DnsSettings enterprise_id={id} domain={domain} />
          </TabPanel>
        </TabView>
      </Panel>
    </>
  );
};

export default ConfigWebSite;
